import { Component, OnInit } from '@angular/core';
import { Chart } from 'chart.js';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { Stages } from 'src/app/shared/components/dashboard/stages/stages.component';
import { AuthServiceService } from 'src/app/shared/services/auth-service.service';
import { ClientsUsersService } from 'src/app/shared/services/other-services/clients-users.service';

export interface Totals {
  towns: number;
  stations: number;
  stages: Stages;
  clients: number;
  clientsBorrowed: number;
  clientsSaved: number;
  clientsPaid: number;
  clientsPaidInFull: number;
  clientsPaidInInstallment: number;
  deptRecovered: number;
  amountRecovered: number;
  amountUnPaid: number;
  floatAmount: number;
  loans: number;
  bodaDefaulters: number;
  taxiDefaulters: number;
  microDefaulters: number;
  bodaRecovery: number;
  taxiRecovery: number;
  microRecovery: number;
  bodaEnforcement: number;
  taxiEnforcement: number;
  microEnforcement: number;
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  totals: Totals = {
    towns: 12,
    stations: 10,
    stages: { boda: 5, taxi: 6 },
    clients: 10,
    clientsBorrowed: 2,
    clientsSaved: 2,
    clientsPaid: 2,
    clientsPaidInFull: 2,
    clientsPaidInInstallment: 2,
    deptRecovered: 2,
    amountRecovered: 2,
    amountUnPaid: 2,
    floatAmount: 2,
    loans: 2,
    bodaDefaulters: 2,
    taxiDefaulters: 2,
    microDefaulters: 2,
    bodaRecovery: 2,
    taxiRecovery: 2,
    microRecovery: 2,
    bodaEnforcement: 2,
    taxiEnforcement: 2,
    microEnforcement: 2,
  };

  User = this.authService.loggedInUserInfo();
  lineChartData: Chart.ChartDataSets[] = [
    {
      label: 'Clients',
      fill: false,
      lineTension: 0.1,
      backgroundColor: 'rgba(75,192,192,0.4)',
      borderColor: 'rgba(75,192,192,1)',
      borderCapStyle: 'butt',
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: 'miter',
      pointBorderColor: 'rgba(75,192,190,1)',
      pointBackgroundColor: '#fff',
      pointBorderWidth: 1,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: 'rgba(75,192,192,1)',
      pointHoverBorderColor: 'rgba(220,220,220,1)',
      pointHoverBorderWidth: 1,
      pointRadius: 1,
      pointHitRadius: 10,
      data: [20, 59, 73, 61, 56, 40, 70]
    },
    {
      label: 'Payments',
      fill: false,
      lineTension: 0.1,
      backgroundColor: 'rgba(75,192,192,0.4)',
      borderColor: 'rgba(75,192,192,1)',
      borderCapStyle: 'butt',
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: 'miter',
      pointBorderColor: 'rgba(75,190,190,1)',
      pointBackgroundColor: '#fff',
      pointBorderWidth: 1,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: 'rgba(75,192,192,1)',
      pointHoverBorderColor: 'rgba(220,220,220,1)',
      pointHoverBorderWidth: 1,
      pointRadius: 1,
      pointHitRadius: 10,
      data: [10, 39, 53, 31, 36, 40, 50]
    },
    {
      label: 'Borrowing',
      fill: false,
      lineTension: 0.1,
      backgroundColor: 'rgba(75,192,192,0.4)',
      borderColor: 'rgba(75,192,192,1)',
      borderCapStyle: 'butt',
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: 'miter',
      pointBorderColor: 'rgba(75,192,192,1)',
      pointBackgroundColor: '#fff',
      pointBorderWidth: 1,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: 'rgba(75,192,192,1)',
      pointHoverBorderColor: 'rgba(220,220,220,1)',
      pointHoverBorderWidth: 1,
      pointRadius: 1,
      pointHitRadius: 10,
      data: [35, 79, 53, 31, 36, 40, 60]
    },
  ];
  lineChartLabels: Array<any> = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
  lineChartOptions: any = {
    responsive: true
  };
  lineChartLegend = true;
  lineChartType = 'line';
  inlinePlugin: any;
  textPlugin: any;
  creationApprovals: Array<any> = [
    { type: "Area Creation", total: 17 },
    { type: "Town Creation", total: 10 },
    { type: "Station Creation", total: 23 },
    { type: "Cluster Creation", total: 15 },
  ];
  transactionApprovals: Array<any> = [
    { type: "Floats", total: 23 },
    { type: "Interests Rates", total: 8 },
    { type: "Reversing", total: 7 },
    { type: "Waiving", total: 15 },
    { type: "Withdraws", total: 15 },
    { type: "Writing Off", total: 6 }
  ];
  topClients: Array<any> = [
    { ID: "AD120", name: "Kiwanuka Mahd" },
    { ID: "AD010", name: "Katumba Mark" },
    { ID: "AD110", name: "Musoke John" },
    { ID: "AD020", name: "Muwonge Mahd" },
    { ID: "AD123", name: "Tom Giraka" }
  ];
  topUsers: Array<any> = [
    { name: "Kiwanuka Mahd", place: "Wakiso East" },
    { name: "Katumba Mark", place: "Central East" },
    { name: "Musoke John", place: "Wakiso West" },
    { name: "Muwonge Mahd", place: "Gomba East" },
    { name: "Tom Giraka", place: "Kyagwe East" }
  ];
  topStations: Array<any> = [
    { name: "Ndeba", town: "kampala", area: "Central Region" },
    { name: "Matugga", town: "Mbale", area: "Eastern Region" },
    { name: "Kiira", town: "Jinja", area: "Central Region" },
    { name: "Katwe", town: "Kisoro", area: "Western Region" },
    { name: "Kibuye", town: "kampala", area: "Central Region" },
  ];

  constructor(
    private authService: AuthServiceService,
    private clientUser: ClientsUsersService
  ) { }

  ngOnInit(): void {
    // inline plugin
    this.textPlugin = [{
      id: 'textPlugin',
      beforeDraw(chart: any): any {
        const width = chart.chart.width;
        const height = chart.chart.height;
        const ctx = chart.chart.ctx;
        ctx.restore();
        const fontSize = (height / 114).toFixed(2);
        ctx.font = `${fontSize}em sans-serif`;
        ctx.textBaseline = 'middle';
        const text = '';
        const textX = Math.round((width - ctx.measureText(text).width) / 2);
        const textY = height / 2;
        ctx.fillText(text, textX, textY);
        ctx.save();
      }
    }];

    this.inlinePlugin = this.textPlugin;
    this.clientUser.getTotalBodaBodaStagesByStation(this.User.userLocationId).subscribe(res => this.totals.stages.boda = res[0].numberOfBodaBodaStagesPerStation);
    this.clientUser.getTotalTaxiStagesByStation(this.User.userLocationId).subscribe(res => this.totals.stages.taxi = res[0].numberOfTaxiStagesPerStation);
    this.clientUser.getTotalClientsByStation(this.User.userLocationId).subscribe(res => this.totals.clients = res[0].numberOfCustomersPerStation);
    this.clientUser.getTotalClientsWhoBorrowedByStation(this.User.userLocationId).subscribe(res => this.totals.clientsBorrowed = res[0].numberOfCustomersBorrowedTodayPerStation);
    this.clientUser.getTotalClientsWhoSavedByStation(this.User.userLocationId).subscribe(res => this.totals.clientsSaved = res[0].numberOfCustomersSavedTodayPerStation);
    this.clientUser.getTotalClientsWhoPaidByStation(this.User.userLocationId).subscribe(res => this.totals.clientsPaid = res[0].numberOfCustomersPaidTodayByStation);
    // this.clientUser.getTotalNoOfClientPaidInFullByStation(this.User.userLocationId).subscribe(res => this.totals.clientsPaidInFull = res[0]);
    // this.clientUser.getTotalNoOfClientPaidInInstalmentByStation(this.User.userLocationId).subscribe(res => this.totals.clientsPaidInInstallment = res[0]);
    // this.clientUser.getTotalNoOfDebtsRecoveredByStation(this.User.userLocationId).subscribe(res => this.totals.deptRecovered = res[0]);
    // this.clientUser.getTotalAmountRecoveredByStation(this.User.userLocationId).subscribe(res => this.totals.amountRecovered = res[0]);
    // this.clientUser.getTotalAmountUnPaidByStation(this.User.userLocationId).subscribe(res => this.totals.amountUnPaid = res[0]);
    // this.clientUser.getTotalFloatAmountByStation(this.User.userLocationId).subscribe(res => this.totals.floatAmount = res[0]);
    // this.clientUser.getTotalLoansByStation(this.User.userLocationId).subscribe(res => this.totals.loans = res[0]);
    this.clientUser.getTotalBodaBodaLoanDefaultersByStation(this.User.userLocationId).subscribe(res => this.totals.bodaDefaulters = res[0].totalBodaBoadLoanDefaultersByStation);
    this.clientUser.getTotalTaxiLoanDefaultersByStation(this.User.userLocationId).subscribe(res => this.totals.taxiDefaulters = res[0].totalTaxiLoanDefaultersByStation);
    this.clientUser.getTotalMicroLoanDefaultersByStation(this.User.userLocationId).subscribe(res => this.totals.microDefaulters = res[0].totalMicroloanDefaultersByStation);
    this.clientUser.getTotalBodaBodaLoanRecoveryByStation(this.User.userLocationId).subscribe(res => this.totals.bodaRecovery = res[0].totalBodaBodaLoanRecoveryByStation);
    this.clientUser.getTotalTaxiLoanRecoveryByStation(this.User.userLocationId).subscribe(res => this.totals.taxiRecovery = res[0].totalTaxiLoanRecoveryByStation);
    this.clientUser.getTotalMicroLoanRecoveryByStation(this.User.userLocationId).subscribe(res => this.totals.microRecovery = res[0].totalMicrolaonRecoveryByStation);
    this.clientUser.getTotalBodaBodaLoanEnforcementByStation(this.User.userLocationId).subscribe(res => this.totals.bodaEnforcement = res[0].totalBodaBodaLoanEnforcementByStation);
    this.clientUser.getTotalTaxiLoanEnforcementByStation(this.User.userLocationId).subscribe(res => this.totals.taxiEnforcement = res[0].totalTaxiLoanEnforcementByStation);
    this.clientUser.getTotalMicroLoanEnforcementByStation(this.User.userLocationId).subscribe(res => this.totals.microEnforcement = res[0].totalMicroLoanEnforcementByStation);
  }
}
